window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const funcHandle = ({ a, b, c}) => {
  // handle something
};
window.BSS_B2B.addAction("handleSomething", funcHandle ); 

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('is-open')) {
             BSS_B2B.nt.initFunction()
              document.dispatchEvent(new Event("DOMContentLoaded"));
            console.log('111111111111')
            function reloadBssScript() { 
              // Tìm thẻ script cũ
              const oldScript = document.querySelector('script[src$="bss-b2b-v3.js"]');
              if (oldScript) oldScript.remove(); 
              // xóa nó khỏi DOM
              
              // Tạo thẻ script mới 
              const newScript = document.createElement('script'); 
              newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-v3.js';
              
              // Khi tải xong thì log lại (không bắt buộc) 
              newScript.onload = () => console.log('Đã reload bss-b2b-v3.js');
              
              // Gắn vào body (hoặc head đều được)
               document.body.appendChild(newScript); }
              
              // Gọi hàm để reload script 
              reloadBssScript(); 
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);

    const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector("#cartDrawerCheckoutForm .cart__foot-inner");
   
    if (footerPrice){
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

    function handleTEBox() {
      const translations = BSS_B2B.te.teTranslations;
      const headerText = document.querySelector(
        ".bss-b2b-translation-vat-form_header_text"
      );
      if (headerText) {
        headerText.innerText = translations.form_header_text;
      }

      const subtitleText = document.querySelector(
        ".bss-b2b-translation-vat-form_subtitle_text"
      );
      if (subtitleText) {
        subtitleText.innerText = translations.form_subtitle_text;
      }

      const successMessages = [
        document.querySelector(".bss-b2b-translation-vat-form_success_message"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
        document.querySelector(
          ".bss-b2b-translation-vat-form_success_message_us_ein"
        ),
      ];

      successMessages.forEach((msg, index) => {
        if (msg) {
          switch (index) {
            case 0:
              msg.innerText = translations.form_success_message || "";
              break;
            case 1:
              msg.innerText = translations.form_success_message_uk || "";
              break;
            case 2:
              msg.innerText = translations.form_success_message_abn || "";
              break;
            case 3:
              msg.innerText = translations.form_success_message_gst || "";
              break;
            case 4:
              msg.innerText = translations.form_success_message_us_ein || "";
              break;
          }
        }
      });

      const errorMessages = [
        document.querySelector(".bss-b2b-translation-vat-form_error_message"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
        document.querySelector(
          ".bss-b2b-translation-vat-form_error_message_us_ein"
        ),
        document.querySelector(
          ".bss-b2b-translation-vat-form_validate_country_code_message"
        ),
      ];

      errorMessages.forEach((msg, index) => {
        if (msg) {
          switch (index) {
            case 0:
              msg.innerText = translations.form_error_message || "";
              break;
            case 1:
              msg.innerText = translations.form_error_message_uk || "";
              break;
            case 2:
              msg.innerText = translations.form_error_message_abn || "";
              break;
            case 3:
              msg.innerText = translations.form_error_message_gst || "";
              break;
            case 4:
              msg.innerText = translations.form_error_message_us_ein || "";
              break;
            case 5:
              msg.innerText = translations.form_validate_country_code_message || "";
              break;
          }
        }
      });
    }
  }

  function process(input) {
    const form = input.closest('[bss-b2b-product-form][bss-b2b-product-form-id]');
    const variantPriceEl = form?.querySelector('.product__price span:last-child');
    const totalPriceEl = form?.querySelector('button[data-add-to-cart] .product__price--regular');

    if (!form || !variantPriceEl || !totalPriceEl) {
        if (totalPriceEl) {
            totalPriceEl.style.visibility = "visible";
        }
        return;
    }

    const { price } =
        BSS_B2B.storage.productFormStorage
            .get(form.getAttribute('bss-b2b-product-form-id'))
            .currentVariant;

    const currPrice =
        Number(variantPriceEl.textContent.replace(/[^0-9.-]+/g, "")) * 100;

    if (price === currPrice) {
        totalPriceEl.style.visibility = "visible";
        return;
    }

    totalPriceEl.textContent =
        BSS_B2B.formatMoney(currPrice * Number(input.value));

    totalPriceEl.style.visibility = "visible";
}

if (BSS_B2B.page.isProductPage()) {
    const input = document.querySelector('.quantity__selector.quantity__input');
    if (input) {
        setTimeout(() => process(input), 2500);
    }
}

window.addEventListener("bss_b2b:loadedObserver", () => {
    const fn = () => {
        const input = document.querySelector('.quantity__selector.quantity__input');
        if (input) process(input);
    };

    const { productObserver } = BSS_B2B.observer;

    productObserver.takeLatest('VariantChange', fn, { priority: 1000 });
    productObserver.takeLatest('QuickviewLoaded', fn, { priority: 1000 });
    productObserver.takeEvery('InputQuantityChange', fn, { priority: 1000 });
});

const cartBtn = document.querySelector('.menu__item--icons .cart__toggle');
if (cartBtn) {
    cartBtn.addEventListener('click', () =>
        setTimeout(
            () => document.dispatchEvent(new Event('bss_b2b:CustomCartUpdate')),
            100
        )
    );
}

let counter = 0;
let selector = "[bss-b2b-product-form='main']"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        clearInterval(interval);
        const productForm = document.querySelector('[bss-b2b-product-form="main"]');
        const product = BSS_B2B.storage.productFormStorage.get(productForm.getAttribute("bss-b2b-product-form-id"))

        const variant = document.querySelector('.product__price[bss-b2b-variant-id]')
        const variantId = variant.getAttribute('bss-b2b-variant-id')
        product.currentVariant = product.variants.find(item => item.id == Number(variantId))
        // BSS_B2B.storage.productFormStorage.set(productForm.getAttribute("bss-b2b-product-form-id"), product);
        // BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 
